import { EntityType } from "@shared/api/model/entity-type"
import { RunDirectionType } from "@shared/api/model/run-direction-type"
import { AuditTrailRoutes, DataReportsRoutes, EntityRoutes, ExplorerRoutes, ReportRoutes, RunRoutes, SharedRoutes, SolverRoutes } from "@shared/shared.routes"
import { AuthAccessCheckType } from "app/auth/models/auth-access-check-type"
import { PolicyType } from "app/auth/models/policy-type"
import { RoleType } from "app/auth/models/role-type"
import { MenuItem } from "primeng/api"

export const auditTrailMenuItemId = "300";

export const menuItems: MenuItem[] = [
    {
        id: "1",
        label: $localize`Home`,
        title: $localize`Home`,
        icon: "assets/icons/ico-home.svg",
        routerLink: SharedRoutes.homeRoute.route
    },
    {
        id: "6",
        label: $localize`Data Quality Management`,
        title: $localize`Data Quality Management`,
        icon: "assets/icons/data-quality.svg",
        items: [
            {
                id: "45",
                label: $localize`Explorer`,
                routerLink: SharedRoutes.dqmRoute.route! + ExplorerRoutes.explorer.route,
            },
            {
                id: "62",
                label: $localize`Entity Report`,
                items: [
                    {
                        id: "63",
                        label: $localize`Bom`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "bom",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Bom",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Bom"
                        },
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Bom]
                            },
                        ]
                    },
                    {
                        id: "65",
                        label: $localize`Calendar`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "calendar",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Calendar",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Calendar"
                        },
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Calendar]
                            },
                        ]
                    },
                    {
                        id: "67",
                        label: $localize`Customer`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "customer",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Customer",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Customer"
                        },
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Customer]
                            },
                        ]
                    },
                    {
                        id: "71",
                        label: $localize`Inventory`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "inventory",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Inventory",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Inventory"
                        },
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Order_Inventory]
                            },
                        ]
                    },
                    {
                        id: "73",
                        label: $localize`Item`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "item",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Item",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Item"
                        },
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Item]
                            },
                        ]
                    },
                    {
                        id: "75",
                        label: $localize`Manufacturing`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "manufacturing",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Manufacturing",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Manufacturing"
                        },
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Order_Manufacturing]
                            },
                        ]
                    },
                    {
                        id: "77",
                        label: $localize`Operation`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "operation",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Operation",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Operation"
                        },
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Operation]
                            },
                        ]
                    },
                    {
                        id: "79",
                        label: $localize`Output`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "output", 
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Output",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Output"
                        },                
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Output]
                            },
                        ]
                    },
                    {
                        id: "81",
                        label: $localize`Purchase`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "purchase",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Purchase",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Purchase"
                        },   
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Order_Purchase]
                            },
                        ]
                    },
                    {
                        id: "83",
                        label: $localize`Resources`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "resource",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Resource",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Resource"
                        }, 
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Resource]
                            },
                        ]
                    },
                    {
                        id: "85",
                        label: $localize`Routing`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "routing",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Routing",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Routing"
                        },
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Routing]
                            },
                        ]
                    },
                    {
                        id: "87",
                        label: $localize`Sales`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "sale",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Sales",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Sales"
                        },
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Order_Sales]
                            },
                        ]
                    },
                    {
                        id: "89",
                        label: $localize`Shift`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "shift",
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Shift",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Shift"
                        },
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Shift]
                            },
                        ]
                    },
                    {
                        id: "91",
                        label: $localize`Subresources`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "subresource",   
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_Subresource",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_Subresource"
                        },   
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Subresource]
                            },
                        ]
                    },
                    {
                        id: "92",
                        label: $localize`Miscellaneous One`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "miscellaneous-one",   
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_MiscellaneousOne",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_MiscellaneousOne"
                        },   
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Miscellaneous_One]
                            },
                        ]
                    },
                    {
                        id: "93",
                        label: $localize`Miscellaneous Two`,
                        routerLink: DataReportsRoutes.baseRoute.paramRoute._ + "miscellaneous-two",   
                        queryParams: {
                            current: "Data_Error_Report_DEEPAPP_Overview_File_1_0_MiscellaneousTwo",
                            analytics: "Data_Error_Report_DEEPAPP_Summary_File_1_0_MiscellaneousTwo"
                        },   
                        authAccess: [
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Administrator_Full]
                            },
                            {
                                policiesAccess: [],
                                rolesAccess: [RoleType.Checks_Miscellaneous_Two]
                            },
                        ]
                    },
                ]
            },
            {
                id: "7",
                label: $localize`Settings`,
                routerLink: SharedRoutes.settingsRoute.route,
            },
        ]
    },
    {
        id: "13",
        label: $localize`Data`,
        title: $localize`Data`,
        icon: "assets/icons/ico-database.svg",
        items: [
            {
                id: "17",
                label: $localize`Import Data`,
                items: [
                    {
                        id: "18",
                        label: $localize`Boms`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Bom,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "19",
                        label: $localize`Calendars`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Calendar,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "20",
                        label: $localize`Customers`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Customer,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "22",
                        label: $localize`Inventories`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Inventory,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "23",
                        label: $localize`Items`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Item,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "24",
                        label: $localize`Manufacturings`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Manufacturing,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "25",
                        label: $localize`Operations`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Operation,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "52",
                        label: $localize`Outputs`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Output,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "53",
                        label: $localize`Purchases`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Purchase,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "54",
                        label: $localize`Resources`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Resource,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "55",
                        label: $localize`Routings`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Routing,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "56",
                        label: $localize`Sales`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Sales,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "57",
                        label: $localize`Shifts`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Shift,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "58",
                        label: $localize`Subresources`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.Subresource,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "59",
                        label: $localize`Miscellaneous One`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.MiscellaneousOne,
                            runDirection: RunDirectionType.Import
                        },
                    },
                    {
                        id: "60",
                        label: $localize`Miscellaneous Two`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.MiscellaneousTwo,
                            runDirection: RunDirectionType.Import
                        },
                    }
                ]
            },
            {
                id: "100",
                label: $localize`Export Data`,
                items: [
                    {
                        id: "101",
                        label: $localize`Bom Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.BomExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "102",
                        label: $localize`Calendar Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.CalendarExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "103",
                        label: $localize`Customer Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.CustomerExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "104",
                        label: $localize`Inventory Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.InventoryExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "105",
                        label: $localize`Item Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.ItemExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "106",
                        label: $localize`Manufacturing Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.ManufacturingExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "107",
                        label: $localize`Operation Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.OperationExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "108",
                        label: $localize`Output Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.OutputExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "109",
                        label: $localize`Purchase Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.PurchaseExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "110",
                        label: $localize`Resource Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.ResourceExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "111",
                        label: $localize`Routing Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.RoutingExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "112",
                        label: $localize`Sale Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.SalesExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "113",
                        label: $localize`Shift Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.ShiftExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "114",
                        label: $localize`Subresource Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.SubresourceExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "115",
                        label: $localize`Miscellaneous One Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.MiscellaneousOneExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    {
                        id: "116",
                        label: $localize`Miscellaneous Two Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.MiscellaneousTwoExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    
                    {
                        id: "117",
                        label: $localize`Order Export`,
                        routerLink: SharedRoutes.entityRoute.route! + EntityRoutes.entityDataRoute.route,
                        queryParams: {
                            entityType: EntityType.OrderExport,
                            runDirection: RunDirectionType.Export
                        },
                    },
                    
                    
                ]
            },
        ]
    },
    {
        id: "14",
        label: $localize`Data Processing`,
        title: $localize`Data Processing`,
        icon: "assets/icons/ico-dataflow.svg",
        items: [
            {
                id: "63",
                label: $localize`Runs`,
                routerLink: SharedRoutes.runRoute.route! + RunRoutes.groupInfoRun.route,
            },
            {
                id: "64",
                label: $localize`Entities`,
                routerLink: SharedRoutes.runRoute.route! + RunRoutes.latestRunEntity.route,
            },
            {
                id: "15",
                label: $localize`Manual run import`,
                routerLink: SharedRoutes.runRoute.route! + RunRoutes.manualRunImportRoute.route,
            },
            {
                id: "16",
                label: $localize`Manual run export`,
                routerLink: SharedRoutes.runRoute.route! + RunRoutes.manualRunExportRoute.route,
            }
        ]
    },
    {
        id: "150",
        label: $localize`Business Intelligence`,
        title: $localize`Business Intelligence`,
        icon: "assets/icons/ico-chart.svg",
        items: [
            {
                id: "151",
                label: $localize`Work Queue`,
                routerLink: SharedRoutes.reportsRoute.route! + ReportRoutes.workQueueRoute.route!,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Administrator_Full]
                    },
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Reports_Work_Queue]
                    },
                ]
            },
            {
                id: "152",
                label: $localize`Inventory Graph`,
                routerLink: SharedRoutes.reportsRoute.route! + ReportRoutes.inventoryGraphRoute.route!,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Administrator_Full]
                    },
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Reports_Inventory_Graph]
                    },
                ]
            },
            {
                id: "153",
                label: $localize`Load Graph`,
                routerLink: SharedRoutes.reportsRoute.route! + ReportRoutes.loadGraphRoute.route!,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Administrator_Full]
                    },
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Reports_Load_Graph]
                    },
                ]
            },
            {
                id: "154",
                label: $localize`Operators`,
                routerLink: SharedRoutes.reportsRoute.route! + ReportRoutes.operatorsRoute.route!,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Administrator_Full]
                    },
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Reports_Operators]
                    },
                ]
            }
        ]
    },
    {
        id: "200",
        label: $localize`Solver`,
        title: $localize`Solver`,
        icon: "assets/icons/ico-schedule.svg",
        authAccess: [
            {
                policiesAccess: [],
                rolesAccess: [RoleType.Solver_User]
            },
        ],
        items: [
            {
                id: "201",
                label: $localize`Jobs`,
                routerLink: SharedRoutes.solverRoute.route! + SolverRoutes.jobsRoute.route!,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Solver_User]
                    },
                ],
            },
            {
                id: "202",
                label: $localize`Runs`,
                routerLink: SharedRoutes.solverRoute.route! + SolverRoutes.runsRoute.route!,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Solver_User]
                    },
                ],
            },
            {
                id: "203",
                label: $localize`Input Data Sets`,
                routerLink: SharedRoutes.solverRoute.route! + SolverRoutes.inputDataSetsRoute.route!,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Solver_User]
                    },
                ],
            },
        ]
    },
    {
        id: auditTrailMenuItemId,
        label: $localize`Audit Trail`,
        title: $localize`Audit Trail`,
        icon: "assets/icons/ico-check.svg",
        authAccess: [
            {
                policiesAccess: [],
                rolesAccess: [RoleType.Administrator_Full, RoleType.AuditTrail_Checks_Read, RoleType.AuditTrail_Data_Modifier, RoleType.AuditTrail_Changes_Controllor],
                rolesCheckType: AuthAccessCheckType.Any
            },
        ],
        items: [
            {
                id: "301",
                label: $localize`Checks`,
                routerLink: SharedRoutes.auditTrailRoute.route! + AuditTrailRoutes.checksRoute.route!,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Administrator_Full]
                    },
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.AuditTrail_Checks_Read, RoleType.AuditTrail_Data_Modifier, RoleType.AuditTrail_Changes_Controllor],
                        rolesCheckType: AuthAccessCheckType.Any
                    },
                ]
            },
            {
                id: "302",
                label: $localize`Last Check`,
                routerLink: SharedRoutes.auditTrailRoute.route! + AuditTrailRoutes.lastCheckRoute.route!,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Administrator_Full]
                    },
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.AuditTrail_Logs_Read],
                        rolesCheckType: AuthAccessCheckType.Any
                    },
                ]
            },
            {
                id: "303",
                label: $localize`Logs Archive`,
                routerLink: SharedRoutes.auditTrailRoute.route! + AuditTrailRoutes.logsArchiveRoute.route!,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Administrator_Full]
                    },
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.AuditTrail_Logs_Read],
                        rolesCheckType: AuthAccessCheckType.Any
                    },
                ]
            },
        ]
    },
    {
        id: "250",
        label: $localize`System Options`,
        title: $localize`System Options`,
        icon: "assets/icons/ico-settings-1.svg",
        authAccess: [
            {
                policiesAccess: [],
                rolesAccess: [
                    RoleType.Administrator_Full, RoleType.ApiAccess_Default, RoleType.Configurations, RoleType.Monitoring_Event_Read,
                    RoleType.DataStreamMessage_AllowedOrigins_Read, RoleType.DataStreamMessage_AllowedOrigins_Write
                ],
                rolesCheckType: AuthAccessCheckType.Any
            },

        ],
        items: [
            {
                id: "251",
                label: $localize`API Access`,
                routerLink: SharedRoutes.apiAccessRoute.route,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Administrator_Full]
                    },
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.ApiAccess_Default]
                    },
                ]
            },
            {
                id: "252",
                label: $localize`Configuration`,
                routerLink: SharedRoutes.configurationRoute.route,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Administrator_Full]
                    },
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Configurations]
                    },
                ]
            },
            {
                id: "253",
                label: $localize`Event Logs`,
                routerLink: SharedRoutes.eventlogsRoute.route,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Administrator_Full]
                    },
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Monitoring_Event_Read]
                    },
                ],
            },
            {
                id: "254",
                label: $localize`Notification options`,
                routerLink: SharedRoutes.allowedOriginsRoute.route,
                authAccess: [
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.Administrator_Full]
                    },
                    {
                        policiesAccess: [],
                        rolesAccess: [RoleType.DataStreamMessage_AllowedOrigins_Read, RoleType.DataStreamMessage_AllowedOrigins_Write],
                        rolesCheckType: AuthAccessCheckType.Any
                    },
                ],
            },
        ]
    }
    // {
    //     id: "26",
    //     label: $localize`Planning`,
    //     title: $localize`Planning`,
    //     icon: "assets/icons/ico-chart-board.svg",
    //     items: [

    //     ]
    // },
    // {
    //     id: "39",
    //     label: $localize`PMT`,
    //     title: $localize`PMT`,
    //     icon: "assets/icons/ico-chart.svg",
    //     items: [

    //     ],
    //     authAccess: [
    //         {
    //             policiesAccess: [],
    //             rolesAccess: [RoleType.Administrator_Full]
    //         },
    //         {
    //             policiesAccess: [PolicyType.ASP_Reader],
    //             rolesAccess: []
    //         },
    //         {
    //             policiesAccess: [],
    //             rolesAccess: [RoleType.PMT]
    //         }
    //     ]
    // }
]

export const userItems: MenuItem[] = [
    {
        id: "30",
        label: $localize`Notifications`,
        authAccess: [],
        styleClass: "md:hidden"
    },
    {
        id: "40",
        label: $localize`Documentation`,
        authAccess: [],
        styleClass: "md:hidden",
        target: "_blank"
    },
    {
        id: "199",
        label: 'Log Out',
        
    }
]
